import * as React from "react";

function SvgActiveMore(props: React.SVGProps<SVGSVGElement>) {
  return <svg width="0.8em" height="0.8em" {...props} />;
}

export default SvgActiveMore;
